import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import Lightbox from "react-image-lightbox";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import ValidationError from "../../components/ValidationError/ValidationError";
import MemberShow from "../Members/MemberShow";
import { numFormat } from "../../hoc/Shared/utility";
import * as actions from "../../store/ducks/delayBonus/actions";

const initialFormInputState = {};

class DelayBonusEdit extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            pageShow: "details",
            remark: null,
            details: {},
            id: null,
            act: "",
            loading: true,
            errMsg: [],
            touched: false,
            rejectReason: [],
            currentImage: "",
            isOpen: false,
            activePage: 1,
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalRecords: 0,
            memberShowId: null,
            formFilter: initialFormInputState,
        };
    }

    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.funcGetDetails(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;

        if (nextProps.details !== this.props.details && nextProps.details !== undefined)
        {
            if (nextProps.details.responseCode === 200 && nextProps.details.msgType === "success") 
            {
                let newDetails = nextProps.details.data.result[0];
                if (
                    nextProps.details.data.result[0] && newDetails.update_by !== null &&
                    newDetails.update_by !== this.props.currentUser.username && (newDetails.status === 0)
                ) 
                {
                    Swal.fire({
                        title: t("global.oops"),
                        text: t("global.transaction-occupied"),
                        icon: "warning",
                        confirmButtonText: "Ok",
                    });
                }
                if (nextProps.details.data.result[0]) 
                {
                    this.setState({
                        remark:
                        this.state.remark !== null
                            ? this.state.remark
                            : newDetails.remark,
                        details: nextProps.details.data.result,
                        id: newDetails.id,
                        loading: false,
                        rejectReason: nextProps.details.data.reject_reason,
                    });
                }
            }
        }

        if (nextProps.update !== this.props.update && nextProps.update !== undefined) 
        {
            if ( nextProps.update.responseCode === 200 && nextProps.update.msgType === "success") 
            {
                Swal.fire({
                    icon: "success",
                    title: t("global.success"),
                    html: t("global.record-updated"),
                    showConfirmButton: true,
                    touched: false,
                    errMsg: []
                }).then(() => {
                    this.props.refreshHandler();
                    const listingArr = this.getFilterArray();
                    this.state.act === "reject" || this.state.act === "approve" ? this.props.changePageHandler("listing") : this.props.funcGetDetails(listingArr);
                });
            } else {
                this.setState({
                    touched: true,
                    errMsg: nextProps.update.message
                });
                Swal.close();
            }
        }
        return true;
    }

    showHandler = (e, id) => {
        e.preventDefault();
        this.setState({
        memberShowId: id,
        pageShow: "show",
        });
    };
    
    getFilterArray = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage &&
            this.setState({ activePage: availablePage });
        }
        
        listingArr.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.id = this.props.detailsParam.id;
        return listingArr;
    };
    
    changePageHandler = (page) => {
        this.setState({
            pageShow: page,
        });
    };
    
    onInputChange = (event) => {
        this.setState({
            remark: event.target.value,
        });
    };
    
    submitHandler = (act, order_id) => {
        const { t } = this.props;
        let rejectReason = {};
        this.state.rejectReason.forEach((val) => {
            rejectReason[val.id] = val.title;
        });
        
        Swal.fire({
            title:
            act === "reject" ? t("validation.reject-reason") : t("validation.confirmation"),
            text: act === "reject" ? "" : t("validation.confirmation_check"),
            input: act === "reject" ? "select" : "",
            inputOptions: rejectReason,
            
            preConfirm: (value) => {
                if (rejectReason[value]) {
                    this.setState({
                        remark: rejectReason[value] || "",
                    });
                }
            },
            
            icon: "warning",
            confirmButtonText: t("global.save"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({
                    act: act,
                });
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                
                let data = {};
                data.id = this.state.id;
                data.remark = this.state.remark;
                data.act = act;
                data.order_id = order_id;
                data.lang_id = this.props.currentUser.language_id;
                this.props.funcUpdateTran(data);
            }
        });
    };
    
    render() {
        const { t } = this.props;
        let rsDetails = this.state.details[0] ? this.state.details[0] : [];
        let stCls = { 0: "primary", 1: "success", 2: "danger", 3: "secondary" };
        let btnPrimary = { 0: t("global.approve") };
        let actVal = { 0: "approve" };
        let permission = this.props.currentUser.permission ? this.props.currentUser.permission : [];
        const num_format = numFormat(rsDetails.currency);
        
        return (
            <Auxiliary>
                {this.state.pageShow === "details" && (
                    <>
                    {this.state.isOpen && (
                    <Lightbox
                        mainSrc={this.state.currentImage}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                    />
                    )}
                    
                    <div className="breadcrumb-header">
                        <div className="d-flex">
                            <div className="my-auto">
                                <Button
                                    typeButton="button"
                                    classValue="btn btn-back-outline"
                                    idValue="back"
                                    buttonName={<i className="angle fe fe-chevron-left"></i>}
                                    clicked={() => this.props.changePageHandler("listing")}
                                />
                            </div>
                        </div>
                        <div className="my-auto">
                            <div className="d-flex">
                                <h4 className="content-title mb-0 my-auto ml-2">
                                    {t("delay-bonus.title")}
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div id="transaction_details">
                        <ValidationError
                            formName="deposit_form"
                            touched={this.state.touched}
                            message={this.state.errMsg}
                        />
                        <div className="row row-sm">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-primary">
                                    <div className="card-header pb-0">
                                        <div className="d-flex justify-content-between">
                                            <h4 className="card-title mg-b-0">
                                                {t("delay-bonus.delay-bonus-details")}
                                            </h4>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="card-body">
                                        {this.state.loading ? (
                                            <Skeleton count={3} />
                                        ) : (
                                            <>
                                                <div className="row row-xs align-items-center mg-b-10 pl-2">
                                                    <div className="col-md-2">
                                                        <label>{t("transaction.order-id")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="order_id"
                                                            id="order_id"
                                                            value={rsDetails.order_id || ""}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 pl-5">
                                                        <label>{t("transaction.member")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="member_id"
                                                            id="member_id"
                                                            value={rsDetails.username || ""}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row row-xs align-items-center mg-b-10 pl-2">
                                                    <div className="col-md-2">
                                                        <label>{t("transaction.transaction-date")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="transaction_date"
                                                            id="transaction_date"
                                                            value={rsDetails.create_date || ""}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 pl-5">
                                                        <label>{t("transaction.amount")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="amount"
                                                            id="amount"
                                                            value={new Intl.NumberFormat("en-US", num_format).format(rsDetails.credit || 0)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row row-xs align-items-center mg-b-10 pl-2">
                                                    <div className="col-md-2">
                                                        <label>{t("transaction.status")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className={`form-control bg-${
                                                            stCls[rsDetails.status]
                                                            } text-white`}
                                                            type="text"
                                                            name="status"
                                                            id="status"
                                                            value={rsDetails.status >= 0 && t(`transaction.status-desc.${rsDetails.status}`)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 pl-5">
                                                        <label> {t("member.country")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="country"
                                                            id="country"
                                                            value={t(`global.country_shortcode.${rsDetails.memberCountry}`) || ""}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="card card-primary">
                                    <div className="card-header pb-0">
                                        <div className="d-flex justify-content-between">
                                            <h4 className="card-title mg-b-0">
                                                {t("transaction.audit-details")}
                                            </h4>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="card-body">
                                        {this.state.loading ? (
                                            <Skeleton count={3} />
                                        ) : (
                                            <>
                                                <div className="row row-xs align-items-center mg-b-10 pl-2">
                                                    <div className="col-md-2">
                                                        <label>{t("transaction.update-date")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="update_date"
                                                            id="update_date"
                                                            value={rsDetails.update_date || ""}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 pl-5">
                                                        <label>{t("transaction.update-by")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="update_by"
                                                            id="update_by"
                                                            value={rsDetails.update_by || ""}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                
                                <div className="card card-primary">
                                    <div className="card-header pb-0">
                                        <div className="d-flex justify-content-between">
                                            <h4 className="card-title mg-b-0">
                                            {t("transaction.others")}
                                            </h4>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="card-body">
                                        {this.state.loading ? (
                                            <Skeleton count={3} />
                                        ) : (
                                            <>
                                                <div className="row row-xs align-items-center mg-b-10 pl-2">
                                                    <div className="col-md-2">
                                                        <label>{t("transaction.remark")}</label>
                                                    </div>
                                                    <div className="col-md-4 mg-t-5 mg-md-t-0">
                                                    <textarea
                                                        className="form-control"
                                                        type="text"
                                                        name="remark"
                                                        id="remark"
                                                        maxLength="255"
                                                        rows="3"
                                                        placeholder={t("transaction.remark")}
                                                        value={this.state.remark || ""}
                                                        onChange={this.onInputChange}
                                                    />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        </div>
                                    </div>

                                    <div className="row row-xs text-center align-items-center mg-b-20">
                                        <div className="col-md-12">
                                            {this.state.loading ? (
                                                <Skeleton count={2} />
                                            ) : (
                                                <>
                                                    {permission.includes("delay_bonus_edit") && (
                                                        <>
                                                            {rsDetails.status === 0 && (
                                                                <>
                                                                    <Button
                                                                        typeButton="button"
                                                                        classValue="btn btn-main-primary"
                                                                        idValue="save"
                                                                        buttonName={btnPrimary[rsDetails.status]}
                                                                        clicked={() =>
                                                                        this.submitHandler(
                                                                            actVal[rsDetails.status],
                                                                            rsDetails.order_id
                                                                        )
                                                                        }
                                                                    />
                                                                    &nbsp;
                                                                </>
                                                            )}
                                                            {rsDetails.status === 0 && (
                                                                <Button
                                                                    typeButton="button"
                                                                    classValue="btn btn-danger"
                                                                    idValue="reject"
                                                                    buttonName={t("global.reject")}
                                                                    clicked={() => this.submitHandler("reject")}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                
                {this.state.pageShow === "show" && (
                    <MemberShow
                        memberShowId={this.state.memberShowId}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        returnPage="details"
                        fromDisplay="edit"
                    />
                )}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    return {
        update: state.delayBonus.update,
        details: state.delayBonus.details,
        currentUser: state.currentUser.data,
    };
};

//Using the redux calling api methods
const mapDispatchToProps = (dispatch) => {
    return {
        funcGetDetails: (filter) => dispatch(actions.getDetails(filter)),
        funcUpdateTran: (data) => dispatch(actions.updateTran(data)),
    };
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(DelayBonusEdit));
